
<template>
  <div class="col column full-height">
    <q-tabs
      :key="isOmni + voiceAttendances + chatAttendances + mailAttendances"

      v-if="isOmni"
      dense
      inline-label
      class="col-auto font-default seg-tabs"
      active-color="white"
      indicator-color="transparent"
      active-class="seg-active"
      v-model="tab"
    >
      <q-tab
        v-if="isOmni && voiceAttendances"
        name="voice"
        icon="mdi-phone-outline"
        label="Voz"
        no-caps
        class="tab-voice"
      >
        <q-badge
          v-if="voiceCurrentCount > 0"
          color="orange-9"
          class="badge"
        >
          {{ voiceCurrentCount }}
        </q-badge>
      </q-tab>

      <q-tab
        v-if="isOmni && chatAttendances"
        name="chat"
        icon="mdi-chat-outline"
        label="Chats"
        no-caps
        class="tab-chat"
      >
        <q-badge
          v-if="chatCurrentCount > 0"
          color="orange-9"
          class="badge"
        >
          {{ chatCurrentCount }}
        </q-badge>
      </q-tab>

      <q-tab
        v-if="isOmni && mailAttendances"
        name="mail"
        icon="mdi-email-outline"
        label="Email"
        no-caps
        class="tab-mail"
      >
        <q-badge
          v-if="mailCurrentCount > 0"
          color="orange-9"
          class="badge"
        >
          {{ mailCurrentCount }}
        </q-badge>
      </q-tab>
    </q-tabs>

    <div class="col scroll">
      <q-tab-panels
        v-model="tab"
        v-if="selectedCurrent.length"
        animated
      >
        <q-tab-panel
          :name="tab"
          class="bg-list q-pa-none"
        >
          <div
            v-for="attendance in selectedCurrent"
            :key="getAttendanceId(attendance)"
          >
            <AttendanceListItem
              :attendance="attendance"
              @onClick="$emit('onClick', getAttendanceId(attendance))"
            />
          </div>
        </q-tab-panel>
      </q-tab-panels>

      <q-tab-panels
        v-model="tab"
        v-if="selectedHistory.length"
      >
        <q-tab-panel
          :name="tab"
          class="q-pa-none"
          :class="[selectedCurrent.length?'bg-history':'bg-list']"
        >
          <q-intersection
            once
            transition="jump-down"
            v-for="attendance in selectedHistory"
            :key="getAttendanceId(attendance)"
          >
            <AttendanceListItem
              :attendance="attendance"
              @onClick="$emit('onClick', getAttendanceId(attendance))"
              @onDblClick="$emit('onDblClick', getAttendanceId(attendance))"
            />
          </q-intersection>
        </q-tab-panel>
        <q-tab-panel
          :name="tab"
          class="q-pa-none"
          :class="[selectedCurrent.length?'bg-history':'bg-list']"
        >
          <q-intersection
            once
            transition="jump-down"
            v-for="attendance in selectedHistory"
            :key="getAttendanceId(attendance)"
          >
            <AttendanceListItem
              :attendance="attendance"
              @onClick="$emit('onClick', getAttendanceId(attendance))"
              @onDblClick="$emit('onDblClick', getAttendanceId(attendance))"
            />
          </q-intersection>
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </div>
</template>

<script>
import AttendanceListItem from '@/components/AttendanceListItem'
export default {
  components: {
    AttendanceListItem
  },

  props: {
    jsonCurrent: String,
    jsonHistory: String,
    header: String
  },

  data () {
    return {
      tab: null,
      currentAttendances: [],
      historyAttendances: [],
      selectedCurrent: [],
      selectedHistory: []
    }
  },

  mounted () {
    this.currentAttendances = this.getCurrentAttendances()
    this.historyAttendances = this.getHistoryAttendances()
  },

  computed: {
    isOmni () {
      return ((this.voiceAttendances ? 1 : 0) + (this.chatAttendances ? 1 : 0) + (this.mailAttendances ? 1 : 0)) > 1
    },

    voiceCurrentCount () {
      return this.selectedCurrentAttendances('voice').length
    },

    chatCurrentCount () {
      return this.selectedCurrentAttendances('chat').length
    },

    mailCurrentCount () {
      return this.selectedCurrentAttendances('mail').length
    },

    voiceHistoryCount () {
      return this.selectedHistoryAttendances('voice').length
    },

    chatHistoryCount () {
      return this.selectedHistoryAttendances('chat').length
    },

    mailHistoryCount () {
      return this.selectedHistoryAttendances('mail').length
    },

    voiceAttendances () {
      return this.voiceCurrentCount > 0 || this.voiceHistoryCount > 0
    },

    chatAttendances () {
      return this.chatCurrentCount > 0 || this.chatHistoryCount > 0
    },

    mailAttendances () {
      return this.mailCurrentCount > 0 || this.mailHistoryCount > 0
    },

    loadingAttendances () {
      if (this.voiceAttendances || this.chatAttendances || this.mailAttendances) return true
      return false
    }

  },

  methods: {
    getCurrentAttendances () {
      try {
        return this.jsonCurrent ? JSON.parse(this.jsonCurrent) : []
      } catch {
        return []
      }
    },

    getHistoryAttendances () {
      try {
        return this.jsonHistory ? JSON.parse(this.jsonHistory) : []
      } catch {
        return []
      }
    },

    selectedCurrentAttendances (option) {
      switch (option) {
        case 'voice':
          return this.currentAttendances.filter((attendance) => attendance.channel === 'VOICE')
        case 'chat':
          return this.currentAttendances.filter((attendance) => attendance.channel === 'TEXT')
        case 'mail':
          return this.currentAttendances.filter((attendance) => attendance.channel === 'MAIL')
      }
      return []
    },

    selectedHistoryAttendances (option) {
      switch (option) {
        case 'voice':
          return this.historyAttendances.filter((attendance) => attendance.channel === 'VOICE')
        case 'chat':
          return this.historyAttendances.filter((attendance) => attendance.channel === 'TEXT')
        case 'mail':
          return this.historyAttendances.filter((attendance) => attendance.channel === 'MAIL')
      }
      return []
    },

    getAttendanceId (attendance) {
      return attendance?.id ?? attendance?.temporaryId
    },

    attendancesTypeDefault () {
      return this.voiceAttendances ? 'voice' : this.chatAttendances ? 'chat' : 'mail'
    },

    validateTab () {
      if (this.tab === 'voice' && !this.voiceAttendances) this.tab = null
      if (this.tab === 'chat' && !this.chatAttendances) this.tab = null
      if (this.tab === 'mail' && !this.mailAttendances) this.tab = null
    }
  },

  watch: {
    jsonCurrent () {
      this.currentAttendances = this.getCurrentAttendances()
      this.validateTab()
      this.tab = this.tab || this.attendancesTypeDefault()
      this.selectedCurrent = this.selectedCurrentAttendances(this.tab)
      this.selectedHistory = this.selectedHistoryAttendances(this.tab)
    },

    jsonHistory () {
      this.historyAttendances = this.getHistoryAttendances()
      this.validateTab()
      this.tab = this.tab || this.attendancesTypeDefault()
      this.selectedCurrent = this.selectedCurrentAttendances(this.tab)
      this.selectedHistory = this.selectedHistoryAttendances(this.tab)
    },

    tab (option) {
      this.selectedCurrent = this.selectedCurrentAttendances(option)
      this.selectedHistory = this.selectedHistoryAttendances(option)
    }
  }
}
</script>

<style lang="sass" >
  .badge
    font-size: 11px
    line-height: 13px
    padding: 1px 5px
    margin-left: 4px
    border-radius: 9999px

  .tab-voice .q-tab__icon, .tab-chat .q-tab__icon, .tab-mail .q-tab__icon
    color: #1769B6

  .seg-tabs
    background: #FFFFFF
    border: 1px solid #CDDCE5
    border-radius: 9999px
    margin: 2px 6px 8px
    padding: 3px

    .q-tab
      border-radius: 9999px
      min-height: 34px
      padding: 0 8px

    .q-tab__icon
      font-size: 18px

    .mdi:before
      font-size: 18px

    .q-tab__label
      margin-left: 4px
      font-size: 12px

    .q-tab:not(.seg-active) .q-tab__label
      display: none

    .q-tab__indicator
      display: none

  .seg-active
    background: #1769B6 !important

    .q-tab__icon, .q-tab__label
      color: #FFFFFF !important

  .q-tab-panels
    background: transparent

  .bg-list
     background-color: transparent

  .bg-history
    background-color: transparent
    opacity: 0.7

  .q-tab__label
    font-size: 11px

  .q-tabs--dense .q-tab--full
    min-height: 10px

  .q-tab__content
    padding: 0

  .mdi:before, .mdi-set
    font-size: 22px

</style>
